module.exports = __webpack_public_path__ + "img/workDocsIconLarge.bbeac736.png";